import { render, staticRenderFns } from "./SalesChannelsConfigComponent.vue?vue&type=template&id=27418b48&scoped=true&"
import script from "./SalesChannelsConfigComponent.vue?vue&type=script&lang=js&"
export * from "./SalesChannelsConfigComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27418b48",
  null
  
)

export default component.exports